import { useState } from "react";
import { Box, Button, Grid, TextField, Typography } from "@mui/material";
import { collection, query, where, getDocs } from "firebase/firestore";
import { db } from "../services/firebase";
import SimpleBackdrop from "../components/SimpleBackdrop";
import MainHeaderComponent from "../components/HeadComp/MainHeaderComponent";
import ImageModel from "../components/ImageModel";

const StatusRequest = () => {
    const [rCodeNumber, setRCodeNumber] = useState("");
    const [errorRCodeMesg, setErrorRCodeMesg] = useState("");
    const [screenLoading, setScreenLoading] = useState(false);
    const [dataAvailable, setdataAvailable] = useState([]);
    const [statusAvailable, setStatusAvailable] = useState("");
    const [open, setOpen] = useState(false);
    const [currentImage, setCurrentImage] = useState("");

    const onRCodeHandle = (e) => {
        const Code = e.target.value;
        const numericRCode = Code.replace(/\D/g, '');
        setRCodeNumber(numericRCode);
        if (numericRCode.length === 10) {
            setErrorRCodeMesg("");
        } else {
            setErrorRCodeMesg("Please enter a valid 10-digit Phone number.");
        }
    };

    const onCheckClick = async () => {
        setScreenLoading(true);
        try {
            const q = query(
                collection(db, 'sign_board_requests'),
                where("phoneNumber", "==", rCodeNumber)
            );
            const querySnapshot = await getDocs(q);
            if (!querySnapshot.empty) {
                const dataArray = [];
                querySnapshot.forEach((doc) => {
                    const data = doc.data();
                    dataArray.push(data);
                });
                console.log(dataArray);
                setStatusAvailable("Found");
                setdataAvailable(dataArray);
            } else {
                setStatusAvailable("No data found with this Phone number.");
            }
            setScreenLoading(false);

        } catch (error) {
            setScreenLoading(false);
            setStatusAvailable("Error, Please try again later.");
            // console.error("Error fetching document: ", error);
        }
    }

    const formatDate = (timestamp) => {
        const date = new Date(timestamp);
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    };

    const getVerificationColor = (status) => {
        switch (status) {
            case "Not Verified":
            case "Rejected":
                return "red";
            case "In Progress":
                return "orange";
            case "Completed":
                return "green";
            default:
                return "black";
        }
    };

    const handleOpen = (imageURL) => {
        setCurrentImage(imageURL);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setCurrentImage("");
    };

    return (
        <Box sx={{ maxWidth: "100%", minWidth: 300, }}>
            <MainHeaderComponent />
            <Box
                sx={{ height: "10vh" }}
            ></Box>
            <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
                <Box sx={{ width: "300px", }}>
                    <Typography>Check your application status :</Typography>
                    <Box p={1} />
                    <TextField
                        label="Phone Number"
                        name="rCodeNumber"
                        placeholder="000xxxx000"
                        variant="outlined"
                        fullWidth
                        required
                        value={rCodeNumber}
                        onChange={(e) => onRCodeHandle(e)}
                        inputProps={{ maxLength: 10, inputMode: 'numeric', pattern: '[0-9]*' }}
                    />
                    <Typography sx={{ fontSize: "10px", color: "red", marginBottom: 2 }}>{errorRCodeMesg}</Typography>
                    <Button variant="contained" color="primary"
                        fullWidth
                        disabled={((rCodeNumber === "") || (rCodeNumber.length < 10)) ? true : false}
                        onClick={() => onCheckClick()}>
                        Check Status
                    </Button>
                    <SimpleBackdrop open={screenLoading} />
                </Box>
            </Box>

            <Box sx={{ display: "flex", justifyContent: "center", my: 3 }}>
                {
                    ((statusAvailable === "No data found with this Phone number.") || (statusAvailable === "Error, Please try again later.")) &&
                    <Box sx={{
                        boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                        p: 2, mt: 3,
                    }}>
                        <Typography sx={{ color: "red" }}>{statusAvailable}</Typography>
                    </Box>
                }
                <ImageModel currentImage={currentImage} open={open} handleClose={handleClose} />
                {
                    (statusAvailable === "Found") &&
                    (
                        <Box sx={{ display: "flex", flexDirection: { xs: "column", md: "row" }, alignItems: "center", gap: "1rem" }}>
                            {
                                dataAvailable.map((da, i) => (
                                    <Box
                                        key={i}
                                        sx={{
                                            boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                                            p: 2,
                                            borderRadius: 3,
                                            width: "300px"
                                        }}
                                    >
                                        <Typography>
                                            <strong>Created Date:</strong> {formatDate(da.createdAt)}
                                        </Typography>
                                        <Typography>
                                            <strong>Name: </strong> {da.fullName}
                                        </Typography>
                                        <Typography>
                                            <strong>Address:</strong> {da.address}
                                        </Typography>
                                        <Typography>
                                            <strong>Request:</strong> {da.request}
                                        </Typography>
                                        <Typography>
                                            <strong>Width * Height:</strong> {da.boardWidth} * {da.boardHeight}
                                        </Typography>
                                        <Typography>
                                            <strong>Description:</strong> {da.description}
                                        </Typography>
                                        <Typography>
                                            <strong>Image:</strong>{" "}
                                            {da.fileURL ? (
                                                <a
                                                    href="#"
                                                    onClick={(e) => {
                                                        e.preventDefault(); // Prevent link navigation
                                                        handleOpen(da.fileURL);
                                                    }}
                                                >
                                                    View Image
                                                </a>
                                            ) : (
                                                "No Image"
                                            )}
                                        </Typography>
                                        <Typography>
                                            <strong>Status:</strong>{" "}
                                            <span style={{ color: getVerificationColor(da.isVerified) }}>
                                                {da.isVerified}
                                            </span>
                                        </Typography>
                                    </Box>
                                ))
                            }
                        </Box>
                    )

                }
                {/* {
                    statusAvailable === "Completed" &&
                    <Box sx={{
                        boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                        p: 2, mt: 3,
                    }}>
                        <Typography>Application Status <span style={{ color: "green", fontWeight: "bold" }}>{statusAvailable}</span></Typography>
                    </Box>
                }
                {
                    ((statusAvailable === "Not Verified") || (statusAvailable === "Rejected")) &&
                    <Box sx={{
                        boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                        p: 2, mt: 3,
                    }}>
                        <Typography >Application Status <span style={{ color: "red", fontWeight: "bold" }}>{statusAvailable}</span></Typography>
                    </Box>
                }

                {
                    (statusAvailable === "In Progress") &&
                    <Box sx={{
                        boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                        p: 2, mt: 3,
                    }}>
                        <Typography >Application Status <span style={{ color: "orange", fontWeight: "bold" }}>{statusAvailable}</span></Typography>
                    </Box>
                } */}
            </Box>
        </Box>
    );
};

export default StatusRequest;